import { env } from '@/config/env'
import type { Auth0ProviderOptions } from '@auth0/auth0-react'

/**
 * Auth0 SDK configuration
 * Uses environment variables for tenant-specific settings
 */
export const auth0Config: Auth0ProviderOptions = {
  domain: env.AUTH0_DOMAIN,
  clientId: env.AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: env.AUTH0_REDIRECT_URI,
    // Only include audience if configured - required for API access tokens,
    // but optional for basic authentication (MVP without backend)
    ...(env.AUTH0_AUDIENCE && { audience: env.AUTH0_AUDIENCE }),
    scope: 'openid profile email',
  },
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
}

/**
 * Custom namespace for AerialFlow claims in Auth0 tokens
 * Auth0 requires custom claims to use a URL namespace
 */
export const AUTH0_NAMESPACE = 'https://aerialflow.com'

/**
 * Auth0 claim keys used in ID and access tokens
 */
export const AUTH0_CLAIMS = {
  ROLES: `${AUTH0_NAMESPACE}/roles`,
  STUDIOS: `${AUTH0_NAMESPACE}/studios`,
  PRIMARY_STUDIO: `${AUTH0_NAMESPACE}/primary_studio`,
} as const
